<template>
   <template v-for="menu in list" :key="menu.key">
    <a-sub-menu
      v-if="menu.children?.length"
      :key="menu.key"
    >
      <template #icon v-if="menu.meta?.icon">
        <component :is="menu.meta.icon" />
      </template>
      <template #title v-if="menu.meta?.new">
        {{ menu.label }}
        <span class="news">new</span>
      </template>
      <template #title v-else>
        {{ menu.label }}
      </template>
      <menus :list="menu.children" />
    </a-sub-menu>

    <template v-else>
      <li
        v-if="menu.target"
        class="ant-menu-item"
        style="padding-left: 24px;"
        @click="openUrl(menu.target)"
      >
        <template v-if="menu.meta?.icon">
          <component :is="menu.meta.icon" />
        </template>
        <span class="ant-menu-title-content ml10">
          {{ menu.label }}
        </span>
      </li>
      <a-menu-item v-else :key="menu.key">
        <template #icon v-if="menu.meta?.icon">
          <component :is="menu.meta.icon" />
        </template>
        <div v-if="menu.meta?.new">
          {{ menu.label }}
          <span class="news">new</span>
        </div>
        <div v-else>
          {{ menu.label }}
        </div>
      </a-menu-item>
    </template>
  </template>
</template>

<script lang="ts" setup>
interface Props {
  list: any[]
}

defineProps<Props>()
const openUrl = url => window.open(url)
</script>
<style scoped>
  .news {
    display: inline-block;
    width: 40px;
    height: 18px;
    line-height: 16px;
    font-size: 12px;
    color: #f8403f;
    margin-left: 16px;
    text-align: center;
    background-color: #fff1f0;
  }
</style>